"use client";
import Link from "next/link";
import {FaAngleDown, FaArrowDown, FaFacebookF, FaInstagram, FaLinkedin} from "react-icons/fa";
import Image from "next/image";
import {Button} from "@/components/ui/button";
import NewsletterForm from "@/components/site/landing/NewsletterForm";
import { Disclosure } from '@headlessui/react'
import {getAssetUrl} from "@/lib/helpers/getAssetUrl";

export default function FooterLanding({items, socialNetworks,logo}){
    return(
        <footer className={"bg-[#F7CE79] mt-10"}>
            <section className={"hidden md:grid md:grid-cols-4 px-10 lg:px-20 py-14"}>
                {items.map(function (item, index) {
                    return (
                        <aside key={index}>
                            <h4 className={"text-2xl font-medium text-white"}>{item.column}</h4>
                            <div className={"flex flex-col gap-y-4 text-xl text-white pt-5"}>
                                {item.items.map(function (it, i) {
                                    return (
                                        <Link href={it.link} key={i} >
                                            <button  className={"hover:underline"}>
                                                {it.label}
                                            </button>
                                        </Link>
                                    )
                                })}
                            </div>
                        </aside>
                    )
                })}
                <aside className={"flex flex-col gap-y-3"}>
                    <h4 className={"text-2xl font-medium text-white"}>Abonnez vous</h4>
                    <p className={"text-xl text-white font-medium"}>Suivez notre actualité</p>
                    <NewsletterForm/>
                    <p className={"text-white text-sm"}>
                        En vous abonnant, vous acceptez notre politique de confidentialité et consentez à recevoir des
                        mises à jour de notre société.
                    </p>
                    <div className={"flex justify-end"}>
                        <img src={getAssetUrl(logo)} alt={"Coworkfit logo"} width={150} height={101}/>
                    </div>
                </aside>
            </section>
            <section className={"flex flex-col gap-y-2 items-start md:hidden px-10 pt-2 "}>
                {items.map(function (item, index) {
                    return (
                        <Disclosure key={index}>
                            {({open}) => (
                                <>
                                    <Disclosure.Button className={"text-xl font-normal text-white flex justify-between w-full"}>
                                        {item.column}
                                        <FaAngleDown className={`${open ? 'rotate-180 transform' : ''} text-white`}/>
                                    </Disclosure.Button>
                                    <Disclosure.Panel className={"flex flex-col gap-y-1 text-white pt-2"}>
                                        {item.items.map(function (it, i) {
                                            return (
                                                <Link href={it.link} key={i}>
                                                    <button className={"hover:underline"}>
                                                        {it.label}
                                                    </button>
                                                </Link>
                                            )
                                        })}
                                    </Disclosure.Panel>
                                </>
                            )}

                        </Disclosure>
                    )
                })}
                <aside className={"flex flex-col gap-y-3"}>
                    <h4 className={"text-2xl font-medium text-white text-center pt-5"}>Abonnez vous</h4>
                    <p className={"text-xl text-white font-medium"}>Suivez notre actualité</p>
                    <NewsletterForm/>
                    <p className={"text-white text-sm"}>
                        En vous abonnant, vous acceptez notre politique de confidentialité et consentez à recevoir des
                        mises à jour de notre société.
                    </p>
                    <div className={"flex justify-center"}>
                        <img src={getAssetUrl(logo)} alt={"Coworkfit logo"} width={150} height={101}/>
                    </div>
                </aside>
            </section>
            <section className={"py-2 md:py-5"}>
                <hr className={"border-white"}/>
                <div className={"py-2 flex flex-col-reverse md:flex-row justify-center gap-1 md:gap-4 items-center text-sm text-white"}>
                    <p>©{new Date().getFullYear()} CWF-Coworkfit. Tous droits réservés.</p>
                    <button className={"hover:underline"}>
                        <Link href={"/mentions-legales"}>
                            Mentions légales
                        </Link>
                    </button>
                    <button className={"hover:underline"}>
                        <Link href={"/politique-confidentialite"}>
                            Politique de confidentialité
                        </Link>
                    </button>
                </div>
                <div className={"flex text-white gap-x-6 items-center justify-center"}>
                    {socialNetworks.map(function(social, index){
                        return(
                            <Link href={social.links} key={index} target={"_blank"}>
                                {getSocialIcon(social.type[0], 24)}
                            </Link>
                        )
                    })}
                </div>
            </section>
        </footer>
    )
}


function getSocialIcon(type, size){
    switch(type){
        case 'instagram' :
            return <FaInstagram size={size}/>
        break;
        case 'facebook':
            return <FaFacebookF size={size}/>
        break;
        case 'linkedin':
            return <FaLinkedin size={size}/>
        break;
        default :
            return <></>
        break;
    }
}